import { StoreAppAPI } from '../core/src/storeapp-api-client';

export const RECEIVE_COMPARE_RESULTS_V2 = 'RECEIVE_COMPARE_RESULTS_V2';
export const RECEIVE_COMPARE_RESULTS = 'RECEIVE_COMPARE_RESULTS';
export const TOGGLE_COMPARE_MODAL = 'TOGGLE_COMPARE_MODAL';
export const UPDATE_COMPARE_PRODUCTS = 'UPDATE_COMPARE_PRODUCTS';
export const CLEAR_COMPARE_PRODUCTS = 'CLEAR_COMPARE_PRODUCTS';
export const TOGGLE_COMPARE_DRAG = 'TOGGLE_COMPARE_DRAG';
export const SET_COMPARE_ERROR = 'SET_COMPARE_ERROR';

export const receiveCompareResults = (compareResults) => ({
    type: RECEIVE_COMPARE_RESULTS,
    compareResults
});

//TODO: Remove this once all pages are on the new redesign template
export const receiveCompareResultsV2 = (compareResults) => ({
    type: RECEIVE_COMPARE_RESULTS_V2,
    compareResults
});

export const toggleCompareModal = toggle => ({
    type: TOGGLE_COMPARE_MODAL,
    toggle,
});

export const toggleCompareDrag = isDragging => ({
    type: TOGGLE_COMPARE_DRAG,
    isDragging,
});

export const setCompareError = error => ({
    type: SET_COMPARE_ERROR,
    error,
});

export const updateCompareProducts = products => ({
    type: UPDATE_COMPARE_PRODUCTS,
    products,
});

export const toggleProduct = product => (dispatch, getState) => {
    const { products } = getState().compare;

    const errorTimer = () => {
        setTimeout(() => {
            dispatch(setCompareError(false))
        }, 2000);
        return dispatch(setCompareError(true));
    }

    if (products.length > 0) {
        const attributes = products[0].attributes || {};
        const selectedAttributes = product.attributes || {};

        if (attributes.pm_producttype === selectedAttributes.pm_producttype) {
            if (
                ['Accessories', 'Options and Accessories'].includes(attributes.pm_producttype) &&
                attributes.pm_category !== selectedAttributes.pm_category
            ) {
                return errorTimer();
            }
        } else {
            return errorTimer();
        }
    }

    const newProducts = newCompareArray(product, products);
    dispatch(setCompareError(false));
    return dispatch(updateCompareProducts(newProducts));
};

export const toggleCompareProduct = (product, isV2 = false) => (dispatch, getState) => {
    const { products } = getState().compare;

    dispatch(setCompareError(false));
    let newProducts = newCompareArray(product, products);
    if (newProducts.length > 1) {
        dispatch(fetchCompare(newProducts, 1, 16, isV2)).then(() => {
            return dispatch(updateCompareProducts(newProducts));
        });
    } else {
        dispatch(updateCompareProducts(newProducts));
    }
};

export const getProductCompare = () => (dispatch, getState) => {
    const { products } = getState().compare;
    if (products.length > 1) {
        dispatch(fetchCompare(products, 1, 16, true));
    }
};

export const clearCompareProducts = () => ({
    type: CLEAR_COMPARE_PRODUCTS,
});

export const fetchCompare = (products, skipCache = 1, maxSpecs = 16, v2 = false) => dispatch => {
    const storeAppAPI = new StoreAppAPI();
    const skuList = products.map(product => product.sku);
    const compare = v2 ? storeAppAPI.product.compareV2 : storeAppAPI.product.compare;

    return compare(skuList, skipCache, maxSpecs).then(resp => {
        dispatch(setCompareError(false));
        if (v2) {
            return dispatch(receiveCompareResultsV2(resp.data));
        } else {
            return dispatch(receiveCompareResults(resp.data));
        }
    });
};

const newCompareArray = (product, oldState) => {
    let compareArray = oldState.slice(0);

    let index = compareArray.findIndex(cProduct => cProduct.sku === product.sku);
    if (index === -1) {
        compareArray.unshift(product);
    } else {
        compareArray.splice(index, 1);
    }
    if (compareArray.length > 4) compareArray.pop();
    return compareArray;
};
